import { Box, Link, Typography } from '@mui/material';
import { Span } from 'components/toc-and-privacy/toc-and-privacy.styles';
import { useTranslation } from 'react-i18next';

const PurchaseGiftCardFraudNotice = () => {
  const { t } = useTranslation();

  return (
    <Box mt={1} textAlign="justify">
      <Typography variant="caption">
        {t('giftCard.fraudNotice.text1')}
      </Typography>
      <Link
        href="https://www.incentivio.com/gift-card-fraud-consumer-notice"
        target="_blank"
        aria-label={t('giftCard.fraudNotice.link.ariaLabel')}
        underline="hover"
      >
        <Span>{t('giftCard.fraudNotice.link.text')}</Span>
      </Link>
      <Typography variant="caption">
        {t('giftCard.fraudNotice.text2')}
      </Typography>
    </Box>
  );
};

export default PurchaseGiftCardFraudNotice;
